export default [
	{
		path: '/admin/daily-cash-advances',
		name: 'daily-cash-advance',
		meta: { requiresAuth: true },
		component: () => import('@/pages/expense/daily-cash-advance')
	}
]
